import { Skeleton } from '@/components/ui/Skeleton.tsx';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';

/**
 * Odbicie formularza w trybie edycji — jedynego, który się doczytuje. Kierunek
 * jest tam zamkniętą pigułką, nie przełącznikiem, i tak samo tu.
 */
const FinancialTransactionFormSkeleton = () => {
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-[22px] w-28 rounded-full" />
      </div>

      <div className="space-y-1.5">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-[34px] w-full" />
      </div>

      <TwoInputsRow>
        <div className="flex items-end gap-1">
          <div className="flex-1 space-y-1.5">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-[34px] w-full" />
          </div>
          <Skeleton className="h-[34px] w-20" />
        </div>
      </TwoInputsRow>

      <TwoInputsRow>
        <div className="flex items-end gap-1">
          <div className="flex-1 space-y-1.5">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-[34px] w-full" />
          </div>
          <div className="w-[120px] space-y-1.5">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-[34px] w-full" />
          </div>
        </div>
      </TwoInputsRow>

      <div className="space-y-1.5">
        <Skeleton className="h-4 w-12" />
        <Skeleton className="h-[54px] w-full" />
      </div>

      <div className="space-y-3">
        <div className="space-y-1">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-56" />
        </div>
        <div className="space-y-2 rounded-md border border-neutral-200 p-3">
          <div className="space-y-1.5">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-[34px] w-full" />
          </div>
          <div className="space-y-1.5">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-[34px] w-full" />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <Skeleton className="h-[30px] w-32" />
          <Skeleton className="h-4 w-48" />
        </div>
      </div>
    </div>
  );
};

export default FinancialTransactionFormSkeleton;
